import ModalDialog from "Components/ModalDialog"
import React, {  FunctionComponent } from "react"
import { useSelector } from "react-redux"
import {
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalBodyContainer,
  ModalFooter,
} from "./styled.components"
import Buttons from "../../Components/Buttons"
import Spinner from "../../Components/Spinner"

type CatalogsModalProps = {
  open: boolean
  action?: string
  title: string
  children?: any
  modalSize?: string
  isLoading?: boolean
  handleAcceptClick?: () => void
  handleCancelClick?: () => void
}

const CatalogsModal: FunctionComponent<CatalogsModalProps> = ({
  open,
  action,
  title,
  children,
  modalSize,
  isLoading = false,
  handleAcceptClick,
  handleCancelClick,
}) => {
  const { bannerModal } = useSelector((state: any) => state.theme)
  const { btnSimple } = useSelector((state: any) => state.theme)
  const { catalogs } = useSelector((state: any) => state.theme)

  return (
    <div>
      <ModalDialog
        open={open}
        modalSize={modalSize}
        background={catalogs.backgroundItem}>
        <>
          <ModalHeader
            bgImagen={
              bannerModal
                ? `${process.env.PUBLIC_URL}${bannerModal}`
                : "/commons/bg_profile.png"
            }>
            <ModalTitle textColor={catalogs?.textTitleColor}>
              {title}
            </ModalTitle>
          </ModalHeader>
          <ModalBody>
            <ModalBodyContainer>{children}</ModalBodyContainer>
            <ModalFooter>
              {isLoading ? (
                <Spinner />
              ) : (
                <>
                  <Buttons
                    title={"Cancelar"}
                    type={"cancel-catalog"}
                    config={btnSimple}
                    visible={true}
                    handleClick={handleCancelClick}
                  />
                  <Buttons
                    title={"Guardar"}
                    type={"accept-catalog"}
                    config={btnSimple}
                    visible={action === "view" ? false : true}
                    handleClick={handleAcceptClick}
                  />
                </>
              )}
            </ModalFooter>
          </ModalBody>
        </>
      </ModalDialog>
    </div>
  )
}

export default CatalogsModal
